import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from "react-router-dom";
import BackToTop from '../components/backToTop/BackToTop';
import Quote from '../components/quote/Quote';
/*import TagManager from 'react-gtm-module';*/
import { tracking } from '../functions/Tracking';
import { Action } from '../enums/TrackingActionType';
import { getOpeningHours } from "../functions/OperatingHours";
import { useIsMobile } from "../functions/Theme";
import AdQuestions, { GetMatchingAdQuestionsFromQuestionSet } from "../functions/AdQuestions";

//const tagManagerArgs = {
//    dataLayer: {
//        userId: '001',
//        userProject: 'CAQWeb',
//        page: 'yourquotes'
//    },
//    dataLayerName: 'YourQuotesPageDataLayer'
//}

export default function YourQuotes(props: any) {
    const navigate = useNavigate();
    const [quotes, setQuotes] = useState<any[]>([]);
    const [allQuotes, setAllQuotes] = useState<any[]>([]);
    const [customerDetails, setCustomerDetails] = useState<CustomerDetails>(JSON.parse(localStorage.getItem('customerDetails') || ""));
    const [payAnnual, setPayAnnual] = useState<boolean>(true);
    const [sort, setSort] = useState<string>("");
    const [sortText, setSortText] = useState<string>("Lowest price");
    const isMobile = useIsMobile();

    let pageNo: number = 4;

    if (localStorage.getItem('shortJourney') === "true") {
        pageNo = 3;
    }

    /*TagManager.dataLayer(tagManagerArgs)*/
    props.setSidebarVisibility(false);

    useEffect(() => {
        setQuotes(JSON.parse(localStorage.getItem('quotes') || ""));
        setAllQuotes(JSON.parse(localStorage.getItem('quotes') || ""));
        setCustomerDetails(JSON.parse(localStorage.getItem('customerDetails') || ""));
        props.setCurrentPage(pageNo);
        setSort("price");
        if (localStorage.getItem("changePaymentMethod")) {
            var payAnnual = localStorage.getItem('changePaymentMethod') === "true";
            setPayAnnual(payAnnual);
            localStorage.removeItem("changePaymentMethod");
        }

    }, [])

    useEffect(() => {
        if (quotes.length > 0) {
            sortQuotes();
        }
    }, [sort, payAnnual])

    useEffect(() => {
        props.setQuotesStepperSubHeader(quotes.length);
    }, [quotes])

    function updateQuoteList() {
        setQuotes([...quotes]);
    }

    const backNavigation = () => {
        navigate("/YourBusiness");
    }

    const updatePaymentMethod = (e: React.ChangeEvent<HTMLSelectElement>) => {
        setPayAnnual(e.target.value === "true");
    };

    const updateSort = (e: React.ChangeEvent<HTMLSelectElement>) => {
        setSort(e.target.value);
        let sortTextValue = "";
        if (e.target[e.target.selectedIndex].textContent !== undefined) {
            sortTextValue = e.target[e.target.selectedIndex].textContent || "Lowest price";
        }

        setSortText(sortTextValue);
    };

    const sortQuotes = () => {
        let filteredQuotes = allQuotes;
        if (!payAnnual) {
            filteredQuotes = filteredQuotes.filter(x => x.totalDebt > 0);
        }

        if (sort === "price") {
            if (payAnnual) {
                setQuotes([...filteredQuotes].sort((a, b) =>
                    a.annualPremium > b.annualPremium ? 1 : -1,
                ));
            } else {
                setQuotes([...filteredQuotes].sort((a, b) =>
                    a.totalDebt > b.totalDebt ? 1 : -1,
                ));
            }
        }

        if (sort === "alphabetical") {
            setQuotes([...quotes].sort((a, b) =>
                a.insurerName > b.insurerName ? 1 : -1,
            ));
        }
    }

    const buyCover = (selectedQuote: any) => {
        tracking(Action.SAVE_BUY_PAGE);
        localStorage.setItem('selectedQuote', JSON.stringify(selectedQuote));
        localStorage.setItem('payAnnual', payAnnual.toString());
        navigate("/Payment", {
            state: {
                paymentFailed: false
            }
        });
    }

    return (
        <>
            <div className="form-container">
                <div className="results-form-header">
                    <div className="form-title">
                        <h1>Your quotes</h1>
                    </div>

                    {allQuotes.length > 0 && localStorage.getItem("questions") != null &&
                        <div className="btn-container btn-container-update-details">
                            <button className="btn back update-details" onClick={() => backNavigation()}>
                                Edit quote details
                            </button>
                        </div>
                    }
                </div>

                {allQuotes.length > 0 &&
                    <>
                        <div className="allquotes-container">
                            <div className="filter-sort">
                                <div className="selection-container">
                                    <div className="quote-dropdown">
                                        <label className="pay-method-label" htmlFor="pay-method">Pay</label>
                                        <select
                                            value={payAnnual.toString()}
                                            id="pay-method"
                                            onChange={(e) => updatePaymentMethod(e)}
                                        >
                                            <option value="false">Monthly</option>
                                            <option value="true">Annually</option>
                                        </select>
                                    </div>
                            </div>
                            <AdQuestions />
                            </div>
                            <div className="quote-list">
                                <table className="yourquotes-tbl">
                                {!isMobile && <> <thead>
                                            <tr>
                                                <th>Insurer</th>
                                                {quotes[0].premCovers[0]?.coverName && <th className="value">{quotes[0].premCovers[0].coverName} Cover</th>}
                                                {quotes[0].premCovers[1]?.coverName && <th className="value">{quotes[0].premCovers[1].coverName} Cover</th>}
                                                <th className="value">Price</th>
                                                <th></th>
                                            </tr>
                                </thead></>}

                                    <tbody>
                                        {quotes.map((quote, index) => {
                                            return (
                                                <Quote
                                                    quote={quote}
                                                    payAnnual={payAnnual}
                                                    key={quote.schemeTableID}
                                                    updateQuoteList={updateQuoteList}
                                                    policyNumber={customerDetails.policyNumber}
                                                    buyCover={buyCover} />
                                            )
                                        })}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </>
                }
                {quotes.length === 0 && allQuotes.length > 0 && !payAnnual &&
                    <>
                        <div className="no-quotes">Unfortunately, 25 providers were unable to provide a pay monthly quote based on your requirements. Please swap to pay annually.</div>
                    </>
                }
                {quotes.length > 0 &&
                    <BackToTop />
                }

            </div>

        </>
    )
}